import {
  CompressOutlined, MinusOutlined, PlusOutlined,
} from '@ant-design/icons';
import { Panel, useReactFlow, useStore } from '@xyflow/react';
import {
  Button, Card, Divider, Flex, Typography,
} from 'antd';
import { useCallback } from 'react';

import styles from './AutomationCanvas.module.scss';

export default function ReactFlowControls() {
  const { zoomIn, zoomOut, fitView } = useReactFlow();
  const zoom = useStore((state) => state.transform[2]);

  const handleZoomIn = useCallback(() => {
    zoomIn();
  }, [zoomIn]);

  const handleZoomOut = useCallback(() => {
    zoomOut();
  }, [zoomOut]);

  const handleFitView = useCallback(() => {
    fitView({
      padding: 3,
      duration: 300,
    });
  }, [fitView]);

  return (
    <Panel position="bottom-center">
      <Card
        size="small"
        className={styles.controls}
      >
        <Flex className={styles.controlsCardbody}>
          <Button.Group className={styles.zoomButtons}>
            <Button type="text" icon={<PlusOutlined />} onClick={handleZoomIn} />
            <Typography.Text className={styles.zoomText}>
              {Math.round(zoom * 100)}
              %
            </Typography.Text>
            <Button type="text" icon={<MinusOutlined />} onClick={handleZoomOut} />
          </Button.Group>
          <Divider type="vertical" className={styles.divider} />
          <Button icon={<CompressOutlined />} onClick={handleFitView} />
        </Flex>
      </Card>
    </Panel>
  );
}
